export default __webpack_public_path__ + "static/media/screenplayer_03.ff9a9aa1.png";